import Model from '@/store/plugins/orm/Model'
import ApiService from '@/services/ApiService';
import moment from 'moment-timezone';
import Store from '@/store';

export class Notification extends Model {
    static get entity() {
        return 'notifications';
    }

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            notifiable_id: this.attr(null),
            notifiable_type: this.attr(null),
            code: this.attr(null),
            text: this.attr(null),
            data: this.attr({}),
            read_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            created_by_user_id: this.attr(null),
        };
    }

    static unread() {
        return Notification.all().filter(notification => !notification.read_at)
    }

    static async fetchUnread() {
        if(!Store.getters.isOnline) return

        const response = await ApiService.get('/notifications', {
            params: {
                status: 'unread',
                limit: 10
            }
        })

        Notification.insert({ data: response.data.notifications })
    }

    async markAsRead() {
        this.read_at = moment().utc().format('YYYY-MM-DD HH:mm:ss')
        this.$save()

        const response = await ApiService.post('/notifications/seen', { notification: this.id })

        if(response.data.notification) {
            Notification.update(response.data.notification)
        }
    }
}

export default Notification
